const map = {
	"./1.jpg": 3821,
	"./10.jpg": 5265,
	"./11.jpg": 7108,
	"./12.jpg": 3171,
	"./13.jpg": 3062,
	"./14.jpg": 9261,
	"./15.jpg": 8016,
	"./16.jpg": 1743,
	"./17.jpg": 34,
	"./18.jpg": 4521,
	"./19.jpg": 7644,
	"./2.jpg": 4866,
	"./20.jpg": 8176,
	"./3.jpg": 1247,
	"./4.jpg": 8516,
	"./5.jpg": 6561,
	"./6.jpg": 6950,
	"./7.jpg": 8563,
	"./8.jpg": 9448,
	"./9.jpg": 3413
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5769;